import { render } from "./SubscribeManageList.vue?vue&type=template&id=0040500a&scoped=true&ts=true"
import script from "./SubscribeManageList.vue?vue&type=script&lang=ts"
export * from "./SubscribeManageList.vue?vue&type=script&lang=ts"

import "./SubscribeManageList.vue?vue&type=style&index=0&id=0040500a&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0040500a"]])

export default __exports__